import { render, staticRenderFns } from "./trainingBudgetReview.vue?vue&type=template&id=3138108a"
import script from "./trainingBudgetReview.vue?vue&type=script&lang=js"
export * from "./trainingBudgetReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports